<template>
  <div class="loading-screen">
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: "LoadingScreen",
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: $background-dark;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid rgba($secondary-color, 0.2);
  border-top: 6px solid $primary-color;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>